import React, { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { AppHeader } from './AppHeader';
import { Watermark } from './Watermark';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="dashboard-layout">
      <AppHeader showUserInfo={true} />
      
      <div className="content-with-sidebar">
        <Sidebar isCollapsed={sidebarCollapsed} onToggle={toggleSidebar} />
        
        <main className={`page-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          {children}
        </main>
      </div>
      
      <Watermark />

      <style>{`
        .dashboard-layout {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          background: var(--bg-primary);
        }

        .content-with-sidebar {
          display: flex;
          flex: 1;
          position: relative;
        }

        .page-content {
          flex: 1;
          margin-left: 280px;
          transition: margin-left 0.3s ease;
          padding: 2rem;
          overflow-y: auto;
          background: var(--bg-primary);
          min-height: calc(100vh - var(--header-min-height, 80px));
        }

        .page-content.sidebar-collapsed {
          margin-left: 64px;
        }

        @media (max-width: 768px) {
          .page-content {
            margin-left: 0;
            padding: 1rem;
          }

          .page-content.sidebar-collapsed {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
};